// lib/skillAusGurt.js — Skill-Level aus dem Gurt (Aufgabe 161, Entscheidung 02.10.2026)
//
// Regel (Sascha): Weiß/Gelb/Orange = Beginner · Grün/Blau = Intermediate ·
// Rot/Braun = Advanced · Schwarz (Dan) = Black Belt. Lila/Violett wie bisher
// im Dojo-Abgleich = Advanced.
// Der Verein darf abweichen (Vorschlag); Abweichungen zeigt der Bericht
// „Skill-Level weicht vom Gurt ab“.
//
// Bis 02.10.2026 stand die Regel viermal im Code, jedes Mal etwas anders
// (Vereinsformular, Athletenregistrierung, Dojo-Abgleich; der Hauptweg zum
// Anlegen setzte ohne Angabe einfach 'Beginner'). Gemessen auf Prod: 45
// Schwarzgurte als Advanced, 10 Weißgurte als Intermediate.
//
// ⚠️ Abschrift von backend/utils/skillAusGurt.js — der Test
// utils/__tests__/skillAusGurt.test.js vergleicht beide.

function skillAusGurt(gurtfarbe) {
  const g = String(gurtfarbe || '').trim().toLowerCase();
  if (!g) return null;
  if (g.includes('schwarz') || /\bdan\b/.test(g)) return 'Black Belt';
  if (g.includes('braun') || g.includes('rot') || g.includes('lila') || g.includes('violett')) return 'Advanced';
  if (g.includes('grün') || g.includes('gruen') || g.includes('grun') || g.includes('blau')) return 'Intermediate';
  return 'Beginner';
}

export { skillAusGurt };
